import request from '@/utils/request'

export function getList(cate_code){
  return request({
    url:`/category_list?cate_code=${cate_code}`,
    method:'get',
  })
}

export function getData(pid){
  return request({
    url:`/list_data?pid=${pid}`,
    method:'get',
  })
}

export function downloadData(params) {
  return request({
    url:'/download_data',
    method:'get',
    params
  })
}

export function gridList(pid) {
  return request({
    url: `/grid_list?pid=${pid}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/listdata.js